import React from 'react'
import logo from "../assets/images/health.png"
import { Link, useHistory } from "react-router-dom"

function ComingSoon() {
  const history = useHistory()
  return (
    <div className="comingSoon">
      <div className="image">
        <img src={logo} alt=""  />
      </div>
      <div className="content">
        <h1 className="title">COMING SOON</h1>
        <p className="subtitle">We brought you here and we are sorry</p>
        <p className="text">Our team is currently working hard to get this page running.</p>
        <button> <Link to="/#" onClick={() => history.goBack()}>Go back</Link></button>
      </div>

    </div>
  )
}

export default ComingSoon;